import { graphql } from "../../generated"

export const WELL_PERMISSIONS_SET = graphql(`
    mutation WellPermissionsSet(
        $WellPermissionsSetInput: WellPermissionsSetInput!
    ) {
        wellPermissionsSet(input: $WellPermissionsSetInput) {
            permissions {
                id
                well {
                    id
                    name
                }
            }
            organizationMembership {
                id
                managedAccess
            }
        }
    }
`)
